import { api, ReactQueryOptions } from '@api';
import { useShowToast } from '@hooks/useShowToast';
import { useInvalidate } from '@hooks/TRPC_Hooks/useInvalidate';
type optionsType = ReactQueryOptions['SocialManager']['updateAvatar'];
export const useUpdateAvatar = (options?: optionsType) => {
  const {
    showToast
  } = useShowToast();
  const {
    updateProfileData
  } = useInvalidate();
  return api.SocialManager.updateAvatar.useMutation({
    mutationKey: ['SocialManager.updateAvatar'],
    onSuccess: data => {
      if (data.status === 'reject') {
        showToast({
          variant: 'error',
          text: data.code
        });
      } else {
        showToast({
          variant: 'success'
        });
        updateProfileData();
      }
    },
    onError: () => {
      showToast({
        variant: 'error',
        text: 'error.default'
      });
    },
    ...options
  });
};